import {
  isFieldLengthValid,
  isWebsiteUrlValid,
  isRequiredFieldValid,
  isNameValid,
  containsEmoji,
  getMaxLengthErrorMessage,
  getRequiredFieldErrorMessage,
  getEmojiErrorMessage,
  getDuplicateCompanyErrorMessage,
  getInvalidUrlErrorMessage,
} from '../PyFormValidations';
import type { ProspectOption } from 'components/editor/SidePanel/DocumentSettings/useProspect';
import type { CreateCompanyRequest } from 'services/company-and-contacts/entities';

export { normalizeWebsiteUrl } from '../PyFormValidations';

export const REQUIRED_FIELDS = ['name'];

const TEXT_FIELDS = ['name', 'city', 'address1', 'address2', 'zipCode'];

export const validateField = (field: string, value: string, t: (key: string) => string, prospectOptions: ProspectOption[] = []) => {
  const trimmed = value.trim();

  if (REQUIRED_FIELDS.includes(field) && !isRequiredFieldValid(trimmed)) {
    return { error: getRequiredFieldErrorMessage(t) };
  }

  if (TEXT_FIELDS.includes(field) && trimmed && containsEmoji(trimmed)) {
    return { error: getEmojiErrorMessage(t) };
  }

  if (field === 'name' && trimmed && !isNameValid(trimmed, prospectOptions)) {
    return { error: getDuplicateCompanyErrorMessage(t) };
  }

  if (field === 'websiteUrl' && trimmed && !isWebsiteUrlValid(trimmed)) {
    return { error: getInvalidUrlErrorMessage(t) };
  }

  if (!isFieldLengthValid(value)) {
    return { error: getMaxLengthErrorMessage(t) };
  }

  return { error: '' };
};

export const isFormValid = (values: Record<string, string>, hasErrors: boolean): boolean =>
  REQUIRED_FIELDS.every((field) => isRequiredFieldValid(values[field] || '')) && !hasErrors;

export const mapToRequest = (formValues: Record<string, string>): CreateCompanyRequest => ({
  name: formValues.name,
  websiteUrl: formValues.websiteUrl || undefined,
  address1: formValues.address1 || undefined,
  address2: formValues.address2 || undefined,
  city: formValues.city || undefined,
  stateId: formValues.stateId ? Number(formValues.stateId) : undefined,
  countryId: formValues.countryId ? Number(formValues.countryId) : undefined,
  zipCode: formValues.zipCode || undefined,
});
